import {cloneDeep as _cloneDeep, merge as _merge} from 'lodash'
import { BPointWebParamsType } from '../components/BPointWebForm'
import constants from '../Constants'
import { GroupDescriptor } from '../models/GroupDescriptor'
import { NullableString, Preferito, PreferitoToSaveDto, SdRepository, ServiceDescriptor, Video } from '../models/ServiceDescriptor'
import { User } from '../models/User'
import { CodiceDescrizione, UserContext } from '../models/UserContext'
import { ServiceFilter } from "../filter/serviceFilter";
import { UserSetting } from '../models/UserSetting'
import MyHistory from '../models/MyHistory'
import { News } from '../models/News'
import { Category } from '../models/Category'
import {Carousel} from '../models/Carousel'
import { Result } from '../models/Result'

class ApiService {
    fetchOptions: any
    pushFetchOptions: any
    baseUrl = process.env.PUBLIC_URL
    apiUrl: string
    xSixContext: string;

    constructor(apiUrl: string) {
        this.xSixContext = 'default'
        this.setHeaders()
        this.apiUrl = apiUrl
        console.log(`ApiService::constructor: apiUrl: ${this.apiUrl}`)
        console.log(`ApiService::constructor: process.env:`, process.env)
        console.log(`ApiService::constructor: constants:`, constants)
    }
    setXSixContext(context: string) {
        console.log(`Setting xSixContext: ${context} [Old: ${this.xSixContext}]`)
        this.xSixContext = context
        this.setHeaders()
    }
    setHeaders() {
        this.fetchOptions = {
            credentials: 'include',
            headers: {
                "x-six-context": this.xSixContext
            }
        }
        this.pushFetchOptions = {
            credentials: 'include',
            headers: {
                "Content-Type": 'application/json',
                "x-six-context": this.xSixContext
            }
        }
    }
    setAccessToken(access_token: string | null) {
        const accessToken = access_token
        if(access_token) {
            this.fetchOptions = {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            }
            this.pushFetchOptions = {
                headers: {
                    "Authorization": `Bearer ${accessToken}`,
                    "Content-Type": 'application/json'
                }
            }
        }
    }
    handleErrors(response: any) {
        if (!response.ok) {
            // console.log('handleErrors', response)
            throw Error(response.statusText);
        }
        return response;
    }
    async httpget<RV = any>(url:string, options?: any) {
        console.log(`httpget: ${url} [${options?.method}]`)
        const opt = _merge(_cloneDeep(this.fetchOptions), options)
        const resp = await window.fetch(url, opt)
        if(resp.status === 200) {
            const json = await resp.json()
            return json as RV
        } else if(resp.status === 204) {
            return null;
        } else if(resp.status === 500 || resp.status === 404 || resp.status === 412) {
            const text = await resp.text()
            console.log(`Errore: get ${url}: [${resp.status}]: ${text}`)
            throw text;
        } else {
            throw new Error(`Errore: get ${url}: ${resp.status} - ${resp.statusText}`)
        }
    }
    async httpdelete(url:string) {
        return await this.httpget(url, {method: 'DELETE'})
    }
    async httppost<RV = any>(url: string, body: any, options?: any) {
        console.log(`httppost: ${url}`)
        const opt = _merge(_cloneDeep(this.pushFetchOptions), { method: 'POST', body: JSON.stringify(body) })
        _merge(opt, options)
        const resp = await window.fetch(url, opt)
        if(resp.status === 200) {
            const json = await resp.json()
            return json as RV
        } else if(resp.status === 204) {
            return null;
        } else if(resp.status === 500 || resp.status === 404 || resp.status === 412) {
            const text = await resp.text()
            console.log(`Errore post ${url}: [${resp.status}]: ${text}`)
            throw text;
        } else {
            throw new Error(`Errore post ${url}: ${resp.status} - ${resp.statusText}`)
        }
    }
    async httppostspecial(url: string, body: any, options?: any) {
        console.log(`httppost: ${url}`)
        const opt = _merge(_cloneDeep(this.pushFetchOptions), { method: 'POST', body: JSON.stringify(body) })
        _merge(opt, options)
        const resp = await window.fetch(url, opt)
        console.log(`HTTP:PostSpecial ${url}`, resp)
        if(resp.status === 200) {
            const blob = await resp.blob()
            console.log(`HTTP:PostSpecial ${url}`, blob)
            return blob
        } else if(resp.status === 204) {
            return null;
        } else if(resp.status === 500 || resp.status === 404 || resp.status === 412) {
            const text = await resp.text()
            console.log(`Errore post ${url}: [${resp.status}]: ${text}`)
            throw text;
        } else {
            throw new Error(`Errore post ${url}: ${resp.status} - ${resp.statusText}`)
        }
    }
    async httpput(url: string, body: any) {
        return await this.httppost(url, body, {method: 'PUT'})
    }
    // --------------------------------------------------------------------------------------------
    // L'estrazione del contesto è basata su precondizioni per la definizione dell'utente
    // Sono ammesse autorizzazioni di tipo Provincia, Ufficio, ListaProvince, ListaUffici
    // Altro viene considerato come un utente non configurato correttamente
    // --------------------------------------------------------------------------------------------
    extractXSixContext(u: User) {
        // console.log('extractXSixContext:', u)
        if(u.xSixContext) return u.xSixContext;
        const code = u.claims?.find(x => x.type === 'sx.co')?.value
        let prov = u.claims?.find(x => x.type === 'sx.pr')?.value
        let uffi = u.claims?.find(x => x.type === 'sx.uf')?.value
        const livello = u.claims?.find(x => x.type === 'sx.lv')?.value
        const role = u.claims?.find(x => x.type === 'role')?.value
        // Se non ci sono ne' provincia, ne' ufficio e ne' codice allora
        // se role e' admin impostiamo P;PROD.00000;00
        if(!prov && !uffi && !code && role === "admin") return 'P;PROD.00000;00'
        let ctx = ''
        if(!prov && uffi) {
            prov = uffi.split('.')[1].substr(0,2)
        } else if(!prov && !uffi && livello !== 'Siaer') {
            return 'E;ERROR.*****;**'
        } else if(prov && !uffi) {
            uffi = `PROD.${prov}000`
        }
        if(code) {
            ctx = `C;${code};00`
        } else if(livello === 'Ufficio') {
            ctx = `U;${uffi};${prov}`
        } else {
            ctx = `P;${uffi};${prov}`
        }
        return ctx
    }
    // --------------------------------------------------------------------------------------------
    // API : Chiamate varie
    // --------------------------------------------------------------------------------------------
    async getUser() {
        const user = await this.httpget<User>(`${this.apiUrl}/User`)
        if(user) {
            const ctx = this.extractXSixContext(user)
            // console.log(`Letto utente impostiamo x-six-context ${JSON.stringify(user,null,2)}`)
            // console.log(`x-six-context: ${ctx}`)
            // Estraiamo la mail
            user.mail = user.claims?.find(x => x.type === 'email')?.value
            this.setXSixContext(ctx)
            if(ctx === 'E;ERROR.*****;**') {
                user.notValid = true
            }
        }
        return user
    }
    genUffiLabel(u: CodiceDescrizione, prov: string) {
        const uffiprov = u.codice.split('.')[1].substr(0,2)
        const ufficode = u.codice.split('.')[1].substr(2)
        const rv = prov === '00' 
            ? `${uffiprov} ${ufficode} - ${u.descrizione}`
            : `${ufficode} - ${u.descrizione}`
        return rv
    }
    fillValueLabel(uc: UserContext) {
        uc.province.forEach(p => {
            p.value = p.codiceDb
            p.label = `${p.codiceDb} - ${p.descrizione}`
            p.uffici.forEach(u => {
                u.label = this.genUffiLabel(u, p.codiceDb)
                u.value = u.codice
            })
        })
    }
    async getUserContext() {
        const rv = await this.httpget<UserContext>(`${this.apiUrl}/User/Context`)
        rv && this.fillValueLabel(rv)
        return rv
    }
    async setGetUserContext(provsel: string, type: string, uffi: string) {
        this.setXSixContext(`${type};${uffi};${provsel}`)
        const rv = await this.httpget<UserContext>(`${this.apiUrl}/User/Context/${provsel}/${type}/${uffi}`)
        rv && this.fillValueLabel(rv)
        return rv
    }
    async getApplUrl(appl: string) {
        // console.log(`getApplUrl: ${appl}`)
        return this.httpget<string>(`${this.apiUrl}/Run/${appl}`)
    }
    async getApplUrlFromId(id: number) {
        // console.log(`getApplUrl: ${id}`)
        return this.httpget<string>(`${this.apiUrl}/Run/GetAppl/${id}`)
    }
    async getAppsSd(livello: string) {
        // console.log(`getAppsSd: ${livello}`)
        return this.httpget<ServiceDescriptor>(`${this.apiUrl}/Apps/${livello}`)
    }
    async getGroupDesciptors() {
        // console.log(`getGroupDesciptors`)
        return this.httpget<GroupDescriptor[]>(`${this.apiUrl}/Apps/GroupDescriptors`)
    }
    async getAppsSdForGroup(gid: number) {
        // console.log(`getAppsSdForGroup`)
        return this.httpget<SdRepository>(`${this.apiUrl}/Apps/SdGrouped/${gid}`)
    }
    async getCodici(appl: string, token: string) {
        // console.log(`getAppsSdForGroup`)
        return this.httpget<CodiceDescrizione[]>(`${this.apiUrl}/Apps/Info/${appl}/${token}`)
    }
    async getDemo(q: string) {
        console.log(`getDemo: ${q ?? "None"}`)
        return this.httpget<string>(`${this.apiUrl}/Run/GetDemo?q=${q}`)
    }
    async getPreferiti(userid: string, preferitiRequestNumber?: number) {
        console.log(`getPreferiti: ${userid} ${preferitiRequestNumber}`)
        return this.httpget<Preferito[]>(`${this.apiUrl}/Pref/User/${userid}`)
    }
    async getLinks(userid: string, preferitiRequestNumber?: number) {
        console.log(`getLinks: ${userid} ${preferitiRequestNumber}`)
        return this.httpget<Preferito[]>(`${this.apiUrl}/Pref/Links/${userid}`)
    }
    async checkPrefExistence(sdId: number, context: NullableString, preferito: Preferito) {
        console.log(`checkPrefExistence: ${sdId} ${context}`)
        return this.httpget<{exists: boolean}>(`${this.apiUrl}/Pref/Exists/${sdId}/${preferito?.id}/${context ?? 'NO-CONTEXT'}`)
    }
    async savePreferito(prefToSave: PreferitoToSaveDto, id?: number) {
        console.log(`savePreferito: ${prefToSave.serviceDescriptorId} ${prefToSave.title} [${prefToSave.contesto}]`)
        return this.httppost<Preferito>(`${this.apiUrl}/Pref/Save/${id ?? 0}`, prefToSave)
    }
    async deletePreferito(id: number) {
        console.log(`deletePreferito: ${id}`)
        return this.httpdelete(`${this.apiUrl}/Pref/${id}`)

    }
    async getBPointStartParams(id: number, livello: string, xSixContext: string) {
        console.log(`getBPointStartParams: ${id}, ${livello}, ${xSixContext}`)
        return this.httpget<BPointWebParamsType>(`${this.apiUrl}/start/bpoint?id=${id}&lv=${livello}&ctx=${xSixContext}`)
    }

    async getServiceDesciptors(groupId: number) {
        // console.log(`getGroupDesciptors`)
        return this.httpget<ServiceDescriptor[]>(`${this.apiUrl}/ServiceDescriptor/search?groupId=${groupId}`)
    }

    async getAllServiceDesciptorsFilterAree(aree: string[]) {
        console.log(`getAllServiceDesciptors`)
        const temp = aree.reduce((p,v) => `${p},${v}`)
        return this.httpget<ServiceDescriptor[]>(`${this.apiUrl}/Apps/AllSd?aree=${temp}`)
    }

    async getAllServiceDesciptors() {
        console.log(`getAllServiceDesciptors`)
        return this.httpget<ServiceDescriptor[]>(`${this.apiUrl}/Apps/AllSd`)
    }

    async getServiceDesciptorSearch(description: string, provincia: string, ambiente: string, groupId: number) {
        let filter: ServiceFilter = {ambiente: '', provincia: '', description: ''}
        filter.ambiente = ambiente;
        filter.provincia = provincia;
        filter.description = description;
        filter.groupId = groupId;
        console.log('filter in api', filter)
        // return this.httpget<ServiceDescriptor[]>(`${this.apiUrl}/ServiceDescriptor/search?livello=${groupId}`)
        return this.httppost<ServiceDescriptor[]>(`${this.apiUrl}/ServiceDescriptor/search`, filter)
    }
    
    async getServiceDesciptorSearchPaginated(description: string, provincia: string, ambiente: string, groupId: number, page: number, rowsPerPage: number) {
        let filter: ServiceFilter = {ambiente: '', provincia: '', description: ''}
        filter.ambiente = ambiente;
        filter.provincia = provincia;
        filter.description = description;
        filter.groupId = groupId;
        console.log('filter in api', filter)
        // return this.httpget<ServiceDescriptor[]>(`${this.apiUrl}/ServiceDescriptor/search?livello=${groupId}`)
        return this.httppost<Result<ServiceDescriptor>>(`${this.apiUrl}/ServiceDescriptor/searchpaginated/${page}/${rowsPerPage}`, filter)
    }
    
    async getServiceDesciptor(id: number) {
        console.log('id find', id)
        return this.httpget<ServiceDescriptor>(`${this.apiUrl}/ServiceDescriptor/find/${id}`)
    }
    
    async getVideos() {
        console.log('getVideos')
        return this.httpget<Video[]>(`${this.apiUrl}/Video/list`)
    }
    
    async saveServiceDesciptor(item: ServiceDescriptor) {
        console.log('item to save', item)
        return this.httppost(`${this.apiUrl}/ServiceDescriptor/save`, item)
    }
    
    async deleteServiceDescriptor(id: number) {
        console.log('item to delete', id)
        return this.httpdelete(`${this.apiUrl}/ServiceDescriptor/delete/${id}`)
    }

    async uploadServiceImage(name: string, file: string) {
        console.log('item to upload', file)
        return this.httppost<ArrayBuffer>(`${this.apiUrl}/ServiceDescriptor/upload/${name}`, file)
    }

    async getUserSetting(username: string) {
        console.log('user find', username)
        return this.httpget<UserSetting>(`${this.apiUrl}/usersetting/${username}`) 
    }
    
    async saveUserSetting(item: UserSetting) {
        console.log('item to save', item)
        return this.httppost(`${this.apiUrl}/usersetting`, item)
    }
    
    async updateConsentSetting(setting: UserSetting) {
        console.log('user to save', setting)
        return await this.saveUserSetting(setting)
    }
    
    async getAllIcons() {
        console.log('icons find')
        return this.httpget<string[]>(`${this.apiUrl}/icon`) 
    }
    // async addServiceDesciptor(item: ServiceDescriptorDto) {
    //     console.log('item to save', item)
    //     return this.httppost<ServiceDescriptor>(`${this.apiUrl}/ServiceDescriptor/add`, item)
    // }

    async getHistory() {
        console.log('getHistory')
        return this.httpget<MyHistory[]>(`${this.apiUrl}/History`) 
    }
    
    async getValidNews(aree: string, limit: number = 20) {
        console.log(`getValidNews: ${aree}`)
        return this.httpget<News[]>(`${this.apiUrl}/News/Valid?aree=${aree}&limit=${limit}`)
    }

    async getAllNews(aree: string, limit: number = 20) {
        console.log(`getAllNews: ${aree}`)
        return this.httpget<News[]>(`${this.apiUrl}/News/All?aree=${aree}&limit=${limit}&nota=0`)
    }

    async getValidNotaInformativa(aree: string, limit: number = 20) {
        console.log(`getValidNews: ${aree}`)
        return this.httpget<News[]>(`${this.apiUrl}/News/Valid?aree=${aree}&limit=${limit}&nota=1`)
    }
    
    async getAllNotaInformativa(aree: string, limit: number = 20) {
        console.log(`getAllNotaInformativa: ${aree}`)
        return this.httpget<News[]>(`${this.apiUrl}/News/All?aree=${aree}&limit=${limit}&nota=1`)
    }
    
    async getNews(id: number) {
        console.log(`getNews: ${id}`)
        return this.httpget<News>(`${this.apiUrl}/News/${id}`)
    }
    
    async deleteNews(id: number) {
        console.log(`deleteNews: ${id}`)
        return this.httpdelete(`${this.apiUrl}/News/${id}`)
    }

    async getHistoryWithOptions(order: string = 'date', nrow: number = 20) {
        console.log('getHistory')
        return this.httpget<MyHistory[]>(`${this.apiUrl}/History?order=${order}&nrow=${nrow}`) 
    }
    async deleteHistory(order: string = 'date', keep: number = 20) {
        console.log('deleteHistory')
        return this.httpdelete(`${this.apiUrl}/History`) 
    }
    async deleteHistoryWithOptions(order: string = 'date', keep: number = 20) {
        console.log('deleteHistory')
        return this.httpdelete(`${this.apiUrl}/History?order=${order}&keep=${keep}`) 
    }

    async saveNews(item: News) {
        console.log('item to save', item)
        if(item.validUntil === '') item.validUntil = null!
        return this.httppost(`${this.apiUrl}/News/save`, item)
    }
        
    async getAllAree() {
        console.log('get All Aree')
        return this.httpget<GroupDescriptor[]>(`${this.apiUrl}/aree`) 
    }

    async getAllCategory() {
        console.log('get All Category')
        return this.httpget<Category[]>(`${this.apiUrl}/category`) 
    }
    
    async getCategoryByAree(aree: string) {
        console.log('get All category')
        return this.httpget<Category[]>(`${this.apiUrl}/category/${aree}`)
    }
    
    async getAllCarousel() {
        console.log('get All Carousel')
        return this.httpget<Carousel[]>(`${this.apiUrl}/carousel`) 
    }
    
    async deleteCarousel(id: number) {
        console.log('deleteCarousel')
        return this.httpdelete(`${this.apiUrl}/Carousel/${id}`) 
    }
    
    async saveCarousel(item: Carousel) {
        console.log('item to save', item)
        return this.httppost(`${this.apiUrl}/Carousel/save`, item)
    }
    
    async getCarousel(id: number) {
        console.log('get Carousel')
        return this.httpget<Carousel>(`${this.apiUrl}/carousel/${id}`) 
    }
    
    async savePrefOrder(ids: number[]) {
        console.log(`savePrefOrder: ${JSON.stringify(ids)}`)
        return this.httppost(`${this.apiUrl}/Pref/Reorder`, ids)
    }
    async searchNews(q: string, aree: string, limit: number) {
        // console.log(`searchNews: q = ${q}`)
        return this.httpget<News[]>(`${this.apiUrl}/Search/News?q=${q}&aree=${aree}&limit=${limit}`)
    }
}

const apiService = new ApiService(constants.apiUrl)

export default apiService
